import * as ProfileTypes from './profileTypes';

const initialState = {
    firstName: '',
    lastName: '',
    birthdate: '',
};

export const ProfileReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case ProfileTypes.SET_FIRST_NAME:
            return {
                ...state,
                firstName: action.payload.firstName,
            };
        case ProfileTypes.SET_LAST_NAME:
            return {
                ...state,
                lastName: action.payload.lastName,
            };
        case ProfileTypes.SET_BIRTHDATE:
            return {
                ...state,
                birthdate: action.payload.birthdate,
            };

        case ProfileTypes.CLEAR_STATE:
            return {
                ...initialState,
            };

        default:
            return state;
    }
};
